export default function drawFileToCanvas(
  ctx: CanvasRenderingContext2D,
  file: File,
  width: number,
  height: number
): Promise<void> {
  return new Promise((resolve) => {
    const url = URL.createObjectURL(file)
    const img = new Image()

    img.onload = () => {
      //ctx.save();
      ctx.drawImage(img, 0, 0, width, height)
      //ctx.restore();
      //URL.revokeObjectURL(url);
      resolve()
    }

    img.onerror = () => {
      console.warn('drawFileToCanvas: failed to load image')
      URL.revokeObjectURL(url)
      resolve()
    }

    img.src = url
  })
}
